import { createFileRoute } from '@tanstack/react-router';
import { SigningRequestWizard } from '@features/signing-requests/SigningRequestWizard';

interface NewSigningRequestSearch {
  employeeId?: string;
}

export const Route = createFileRoute('/w/signing-requests/new')({
  staticData: {
    hideShell: true,
    breadcrumb: 'New Signing Request',
    breadcrumbKey: 'K_BREADCRUMB_NEW_SIGNING_REQUEST',
  },
  validateSearch: (search: Record<string, unknown>): NewSigningRequestSearch => ({
    employeeId: typeof search.employeeId === 'string' ? search.employeeId : undefined,
  }),
  component: WorkpayNewSigningRequestPage,
});

function WorkpayNewSigningRequestPage() {
  const { employeeId } = Route.useSearch();
  return <SigningRequestWizard routeTo="/w/signing-requests" employeeId={employeeId} />;
}
